import { z } from 'zod';

export const zEnumBackwardsCompatible = <U extends string>({
  options,
  migrations,
  name,
}: {
  options: Readonly<[U, ...U[]]>;
  migrations: Record<string, U>;
  name: string;
}) => {
  const Enum = z.enum(options).describe(name);

  return {
    Enum,
    Schema: z
      .string()
      .transform((val) => {
        for (const [oldVal, newVal] of Object.entries(migrations)) {
          if (val === oldVal) {
            return newVal;
          }
        }

        return val;
      })
      .pipe(Enum),
  };
};
